<template>
  <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <div style="width: 25%;" class="mb-n9">
        <CommonImportFiles @loadCRUDList="loadBillRequestAfterImport" />
      </div>
      <div>
        <CRUDList class="mt-10" :canAdd="true"
          :canEdit="true" :canSave="true" :showSelect="false" :canDeleteInDialog="true"
          :enableFixedHeaders="true" :displayTopPagination="false"
          :headers="headers" :baseCrudKey="baseCrudKey"
          tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
          tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
          :defaultSortBy="defaultSortBy" @loadCRUDList="handleLoadTransaction"
          :loadingData="gridLoading.flag" :loadingText="gridLoading.text"
          dialogDynamicWidth="400" dialogHeaderName="Assessor X-Ref"
          @upsertItem="upsertRecords" @deleteItem="deleteFromDiaglog" >
            <template v-slot:[`editedItem`]="{ }">
              <AssessorXRefDialog :baseCrudKey="baseCrudKey"/>
            </template>
        </CRUDList>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,

} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { accessorXRefHeaders } from '../../../shared/Utils/taxHeaders.utils';
import { commonFuncForFilterMtgCoProc, makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import AssessorXRefDialog from './assessorXRefDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../../util/shared/vue-global';
import CommonImportFiles from '../../../common/import/CommonImportFiles.vue';
import '../../../../assets/style.css';

export default {
  name: 'AssessorXRef',
  data() {
    return {
      baseCrudKey: 'assessorXRef',
      headers: accessorXRefHeaders,
      gridLoading: defaultGridLoading(),
    };
  },
  components: {
    CRUDList,
    CommonImportFiles,
    AssessorXRefDialog,
  },
  created() {
    this.onCreatedOrMounted('Assessor X Ref Import');
  },
  mounted() {
    this.onCreatedOrMounted('Assessor X Ref Import');
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapState({
      taxDistrictList: (state) => state.base.crud.items.sharedTaxDistrict,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'assessorTaxDistrictCode',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions('tax/newTaxroll', [
      'loadAssessorXRefRecords',
      'upsertAccessorXRef',
      'deleteAccessorXRef',
    ]),
    ...mapMutations('base/crud', ['setCriteria']),
    loadBillRequestAfterImport() {
      this.handleLoadTransaction();
    },
    onCreatedOrMounted(val) {
      const itemData = this.items('transform-mapper-list');
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, 'Assessor File');
      const [filtTaxData] = filteredTaxItemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      // this is to check if the item is empty or not
      const isObjIsEmptyOrNot = Object.keys(item).length > 0;
      if (!isObjIsEmptyOrNot) return;

      const itemValue = { ...item };
      // this is to update the description of the tax district
      const selectedTaxDistrict = this.taxDistrictList.find((dt) => dt.districtCode
       === itemValue.taxDistrictCode);
      if (selectedTaxDistrict) {
        itemValue.taxDistrictDescription = selectedTaxDistrict.districtName || '';
      } else {
        itemValue.taxDistrictDescription = '';
      }
      await this.upsertAccessorXRef({ item: itemValue, baseCrudKey });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteAccessorXRef({ item, baseCrudKey });
      }
    },
    handleLoadTransaction() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const criteria = { ...returnCriteria };
      delete criteria.taxYear;
      this.loadAssessorXRefRecords({
        criteria,
        baseCrudKey: this.baseCrudKey,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
  },
};
</script>
